import { notifyMessage } from 'src/constants/message';
import { notification, RuleObject } from 'core-ui';
import { ErrorResponse } from 'src/models/apiRequest';
import { ROLE_SYSTEM_ADMIN, ROLE_SYSTEM_SUPER_ADMIN } from 'src/constants/auth';
import { RoutePath } from 'src/enums/routePath';

export const handleError = (error: ErrorResponse) => {
  console.error({ error });
  if (error?.status === 403) {
    window.location.href = RoutePath.NOT_PERMISSION;
    return;
  }
  if (error?.status === 404) {
    window.location.href = RoutePath.NOT_FOUND;
    return;
  }
  const { errors: errorData, message: errorMessage } =
    error?.response?.data || {};

  if (!errorData && !errorMessage) {
    return notification.error({
      message: notifyMessage.failed
    });
  }

  if (errorData) {
    Object.keys(errorData).forEach((key) => {
      const errorMessages = errorData[key];
      if (Array.isArray(errorMessages)) {
        errorMessages.forEach((message) => {
          notification.error({ message: String(message) });
        });
      }
    });
  }

  if (!errorData && errorMessage) {
    return notification.error({
      message: errorMessage
    });
  }
};

export const handleSuccess = (successMessage: string) => {
  notification.success({ message: successMessage || notifyMessage.success });
};

export const checkIsSystemSuperAdminOrSystemAdmin = (role: number) => {
  if (role === ROLE_SYSTEM_SUPER_ADMIN || role === ROLE_SYSTEM_ADMIN) {
    return true;
  }
  return false;
};

export const spaceValidator = (
  _: RuleObject,
  value: string | undefined,
  label: string
) => {
  if (value && value.trim().length === 0) {
    return Promise.reject(new Error(`The ${label} field is required.`));
  }
  return Promise.resolve();
};

export const formatWithCommas = (value: any) => {
  if (!value) return;
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const getOrdinalSuffixDaysOfMonth = (n: number): string => {
  const j = n % 10,
    k = n % 100;
  if (j === 1 && k !== 11) return `${n}st`;
  if (j === 2 && k !== 12) return `${n}nd`;
  if (j === 3 && k !== 13) return `${n}rd`;
  return `${n}th`;
};

const getOrdinalSuffix = (day: number) => {
  if (day > 3 && day < 21) return 'th';
  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

export const formatDateWithOrdinal = (
  date: string,
  isToUpperCase?: boolean
) => {
  const d = new Date(date);
  const day = d.getDate();
  const suffix = getOrdinalSuffix(day);
  const month = d.toLocaleString('default', { month: 'long' });
  const year = d.getFullYear();
  return `${day}${suffix} ${isToUpperCase ? month?.toUpperCase() : month} ${year}`;
};

export const handleRenderFee = (
  type: 'registration' | 'licence' | 'total',
  fee: any
) => {
  if (!fee) return '';
  if (type === 'registration') {
    return fee?.registration_fee_usd
      ? `$${formatWithCommas(fee?.registration_fee_usd)} = ₵${formatWithCommas(fee?.registration_fee)}`
      : `₵${formatWithCommas(fee?.registration_fee)}`;
  } else if (type === 'licence') {
    return fee?.licence_fee_usd
      ? `$${formatWithCommas(fee?.licence_fee_usd)} = ₵${formatWithCommas(fee?.licence_fee)}`
      : `₵${formatWithCommas(fee?.licence_fee)}`;
  } else if (type === 'total') {
    return `₵${formatWithCommas(Number(fee?.registration_fee) + Number(fee?.licence_fee))}`;
  }
};
